"use client";

import { useTranslations } from "next-intl";
import {
    LivePerformanceImage1,
    LivePerformanceImage2,
    LivePerformanceImage3,
    LivePerformanceImage4,
    LivePerformanceImage5,
    LivePerformanceImage6,
    LivePerformanceImage7,
    LivePerformanceImage8,
    LivePerformanceImage9,
    LivePerformanceImage10,
    LivePerformanceImage11,
    LivePerformanceImage12,
} from "../../assets";
import UserGuideImage from "./UserGuideImage";

export default function HowToUseLivePerformanceGuide() {
    const t = useTranslations("howToUseLivePerformance");

    return (
        <article className="mx-auto max-w-4xl px-6 py-8 text-[15px] leading-relaxed text-neutral-800 sm:px-10 sm:py-10 sm:text-base">
            <h1 className="mb-8 text-center text-xl font-bold sm:text-2xl">
                {t("headerTitle")}
            </h1>

            <div className="mb-8">
                <UserGuideImage image={LivePerformanceImage1} />
            </div>

            <p className="mb-5 indent-8 text-justify">{t("title1")}</p>
            <p className="mb-5 indent-8 text-justify">{t("title2")}</p>
            <p className="mb-6 indent-8 text-justify">{t("title3")}</p>

            <div className="mb-6">
                <UserGuideImage image={LivePerformanceImage2} />
            </div>

            <p className="mb-6 indent-8 text-justify">{t("title4")}</p>

            <div className="mb-6">
                <UserGuideImage image={LivePerformanceImage3} />
            </div>

            <p className="mb-6 indent-8 text-justify">{t("title5")}</p>

            <div className="mb-6 flex flex-col items-center gap-4 sm:flex-row sm:items-end sm:justify-center sm:gap-6">
                <div className="w-full sm:max-w-[660px]">
                    <UserGuideImage image={LivePerformanceImage4} />
                </div>
                <div className="w-full sm:max-w-[250px]">
                    <UserGuideImage image={LivePerformanceImage5} />
                </div>
            </div>

            <h2 className="mb-4 indent-4 text-base font-bold sm:text-lg">
                {t("stepTitle")}
            </h2>

            <p className="mb-5 indent-8 text-justify">{t("title6")}</p>

            <p className="mb-4 indent-4 text-justify">{t("step1")}</p>
            <p className="mb-4 indent-4 text-justify">{t("step2")}</p>
            <p className="mb-4 indent-4 text-justify">{t("step3")}</p>

            <div className="mb-6">
                <UserGuideImage image={LivePerformanceImage6} />
            </div>

            <p className="mb-4 indent-4 text-justify">{t("step4")}</p>

            <div className="mb-6">
                <UserGuideImage image={LivePerformanceImage7} />
            </div>

            <p className="mb-4 indent-4 text-justify">{t("step5")}</p>
            <p className="mb-4 indent-4 text-justify">{t("step6")}</p>
            <p className="mb-4 indent-4 text-justify">{t("step7")}</p>

            <div className="mb-6">
                <UserGuideImage image={LivePerformanceImage8} />
            </div>

            <p className="mb-4 indent-4 text-justify">{t("step8")}</p>

            <div className="mb-6">
                <UserGuideImage image={LivePerformanceImage9} />
            </div>

            <p className="mb-4 indent-4 text-justify">{t("step9")}</p>
            <p className="mb-4 indent-4 text-justify">{t("step10")}</p>
            <p className="mb-4 indent-4 text-justify">{t("step11")}</p>

            <div className="mb-6">
                <UserGuideImage image={LivePerformanceImage10} />
            </div>

            <p className="mb-4 indent-4 text-justify">{t("step12")}</p>
            <p className="mb-4 indent-4 text-justify">{t("step13")}</p>
            <p className="mb-4 indent-4 text-justify">{t("step14")}</p>
            <p className="mb-4 indent-4 text-justify">{t("step15")}</p>
            <p className="mb-4 indent-4 text-justify">{t("step16")}</p>

            <div className="mb-6">
                <UserGuideImage image={LivePerformanceImage11} />
            </div>

            <p className="mb-4 indent-4 text-justify">{t("step17")}</p>
            <p className="mb-4 indent-4 text-justify">{t("step18")}</p>
            <p className="mb-4 indent-4 text-justify">{t("step19")}</p>

            <div className="mb-2">
                <UserGuideImage image={LivePerformanceImage12} />
            </div>

            <p className="mb-6 indent-4 text-justify">{t("step20")}</p>

            <div className="mb-6 flex flex-col items-center gap-4 sm:flex-row sm:items-end sm:justify-center sm:gap-6">
                <div className="w-full sm:max-w-[660px]">
                    <UserGuideImage image={LivePerformanceImage4} />
                </div>
                <div className="w-full sm:max-w-[250px]">
                    <UserGuideImage image={LivePerformanceImage5} />
                </div>
            </div>

        </article>
    );
}
